import React, { PureComponent } from 'react';
import { omit, keys, isEqual, union } from 'lodash';
import { bemHelper } from '@dbk/ui-react-utils';
import classnames from 'classnames';
import {
  getNewActiveItems,
  getAccordionItems,
  getActiveItemsFromChildProps,
  accordionDefaultProps,
  accordionPropTypes,
  accordionContextTypes,
} from './custom-accordion-common';

import styles from './custom-accordion.css';
import { KEY_CODE } from '../../../constants';

const bem = bemHelper(styles, 'custom_accordion');

class CustomAccordion extends PureComponent {
  static defaultProps = accordionDefaultProps;

  static propTypes = accordionPropTypes;

  static contextTypes = accordionContextTypes;

  constructor(props) {
    super(props);

    this.state = {
      activeItems: this.props.activeItems,
    };
  }

  componentDidMount() {
    const { children, allowMultiple } = this.props;

    const activeFromChildrenItems = getActiveItemsFromChildProps(
      children,
      allowMultiple
    );
    const newActiveItems = union(
      this.state.activeItems,
      activeFromChildrenItems
    );
    this.updateActiveItems(newActiveItems);
  }

  componentWillReceiveProps(newProps) {
    if(!isEqual(newProps.categoryChange, this.props.categoryChange)){
      this.setState({ activeItems: [] });
    }
    if (!isEqual(newProps.activeItems, this.props.activeItems)) {
      this.setState({
        activeItems: newProps.activeItems,
      });
    }
  }

  updateActiveItems(activeItems) {
    const { onChange } = this.props;
    this.setState(
      {
        activeItems,
      },
      () => {
        onChange(this.state.activeItems);
      }
    );
  }

  handleChange = (itemKey,e) => {
    const { allowMultiple } = this.props;

    const activeItems = getNewActiveItems(
      itemKey,
      this.state.activeItems,
      allowMultiple
    );

    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e))
    {
        this.updateActiveItems(activeItems);
    }
  };

  render() {
    const { className, ...rest } = this.props;

    const other = omit(rest, keys(CustomAccordion.defaultProps));
    const classNames = classnames(bem(), className, {
      [bem(null, 'inverse')]: this.context.inverse,
      [bem(null, 'full-width')]: this.props.fullWidth,
    });

    return (
      <div className={classNames} {...other}>
        {getAccordionItems(this.state, this.props, this.handleChange)}
      </div>
    );
  }
}

export default CustomAccordion;
